<template>
  <MarkdownView :text="clean" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import MarkdownView from './MarkdownView.vue';
import type { TraceBlock } from '../../stores/chat';

const props = defineProps<{ block: TraceBlock }>();

// Models sometimes emit EMPTY code fences (```\n```) around tool calls, which
// render as ugly blank code blocks. Strip closed empty fences + collapse the
// blank lines they leave behind. An unclosed fence (mid-stream) is left alone.
const clean = computed(() =>
  (props.block.text ?? '')
    .replace(/```[a-z0-9+-]*[ \t]*\n?[ \t\r\n]*```/gi, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim(),
);
</script>
